import { removeAttachedService } from './attachedServices';
import { filterAndMapAttributes } from '@jbhi-fi/apis/src/utils/filterAndMapAttributes';
import { ShopifyStorefrontClient } from '../../api/shopify/ShopifyStorefrontClient';
import { updateCart, setCartLoading } from './cartUtils';

const storefrontClient = new ShopifyStorefrontClient();

export const removeAttachedServiceOffering = async (attachedServiceLineId: string, serviceLink?: string) => {
  try {
    if (serviceLink) {
      setCartLoading(true);
      removeAttachedService(serviceLink);

      let cart = await storefrontClient.removeFromCart(attachedServiceLineId);
      const primaryItem = cart?.items.find(item => item.properties._serviceLink === serviceLink);
      if (primaryItem) {
        delete primaryItem.properties?._serviceLink;
        delete primaryItem.properties?._isAttachedService;
        delete primaryItem.properties?._legacy_addons_line_key;
        cart = await storefrontClient.updateCartLine(
          primaryItem.line_id,
          undefined,
          filterAndMapAttributes(primaryItem.properties)
        );
      }
      await updateCart(cart);
    }
  } catch (e) {
    console.error(e);
  }
};
